module.exports = __webpack_public_path__ + "static/media/frog(14).540ca559.PNG";